import React from "react";
import DOMPurify from "dompurify";
import formatTime from "./dateUtils"

function EventCard({
  popupRef,
  selectedEvent,
  setSelectedEvent,
}) 
{
  return (
    <div
      ref={popupRef}
      className="event-card"
      style={{
        left: selectedEvent.x,
        top: selectedEvent.y,
      }}
    >
      <button
        className="event-card-close"
        onClick={() => setSelectedEvent(null)}
      >
        ×
      </button>

      <h3 className="event-card-title">
        {selectedEvent.event.title} <br/>
        {formatTime(selectedEvent.event.start)} - 
        {formatTime(selectedEvent.event.end)}
      </h3>
      <div
  className="event-description"
  dangerouslySetInnerHTML={{
    __html: DOMPurify.sanitize(
      selectedEvent.event.extendedProps.description || ""
    ),
  }}
/>
    </div>
  );
}

export default EventCard;